import { TAG_TYPES } from '../constants';

var isStatusTag = function isStatusTag(type) {
  return !!type && [TAG_TYPES.APPROVED, TAG_TYPES.DENIED, TAG_TYPES.NEW].includes(type);
};

export default isStatusTag;